import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

import { useAppSelector } from '../../../lib/store';
import { useGetAnnotationProgressBatchWiseQuery } from '../api/metricsApiSlice';
import { getAllAnnotatorsOption } from '../constants';
import {
  selectBatchwiseProgressEndDate,
  selectBatchwiseProgressStartDate,
  selectSelectedAnnotatorId,
  selectSelectedProjectId,
} from '../state/selector';

export const useBatchProgressDatagridFetch = (
  _searchParams?: string
): ReturnType<typeof useGetAnnotationProgressBatchWiseQuery> => {
  const selectedProjectId = useAppSelector(selectSelectedProjectId);
  const selectedAnnotatorId = useAppSelector(selectSelectedAnnotatorId);
  const startDate = useAppSelector(selectBatchwiseProgressStartDate);
  const endDate = useAppSelector(selectBatchwiseProgressEndDate);
  const { formatMessage } = useIntl();
  const allAnnotatorOption = getAllAnnotatorsOption(formatMessage);

  return useGetAnnotationProgressBatchWiseQuery(
    {
      userId:
        selectedAnnotatorId === allAnnotatorOption.id
          ? undefined
          : selectedAnnotatorId ?? undefined,
      projectId: selectedProjectId || '',
      startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : undefined,
      endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : undefined,
    },
    { skip: !selectedProjectId }
  );
};
